// extracted by mini-css-extract-plugin
export default {"link_container":"ShareLink_link_container__A2lEc"};